import { getPPVRevenue } from 'actions'
import { Shared } from 'components'
import { useQuery } from 'hooks'
import { debounce, mapValues } from 'lodash'
import { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Popup from 'reactjs-popup'
import { renderCell } from 'utilities'
import '../styles.scss'
import { ppvColumns } from 'config/constants'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'

export const PPV = ({ dates }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { sort: sortParam = '{}', filter: filterParam = '{}' } = useQuery()
  const searchQuery = useMemo(
    () => ({
      sortBy: sortParam !== '{}' ? mapValues(JSON.parse(sortParam), (value) => Number(value)) : undefined,
      ...JSON.parse(filterParam),
    }),
    [sortParam, filterParam]
  )

  const { loading, docs, page, hasNextPage, nextPage } = useSelector(({ revenue }) => revenue?.ppvRevenueList)

  const fetch = useCallback(
    ({ getStats, onSuccess, ...payload } = {}) => dispatch(getPPVRevenue({ payload, getStats, onSuccess })),
    [dispatch]
  )
  const fetchDebounced = debounce(fetch, 300)

  const handlePagination = () => hasNextPage && !loading && fetchDebounced({ pageNumber: nextPage, ...searchQuery })

  useEffect(() => {
    fetch({
      ...searchQuery,
      ...(dates?.startDate && { startDate: moment(dates?.startDate)?.format('YYYY-MM-DD') }),
      ...(dates?.endDate && { endDate: moment(dates?.endDate)?.format('YYYY-MM-DD') }),
    })
  }, [fetch, searchQuery, dates])

  const availableSort = ppvColumns.map(({ value }) => value).filter((v) => ![].includes(v))
  const availableFilters = useMemo(() => {
    return {
      event: { type: 'regex' },
    }
  }, [])
  const keyMap = { styles: 'combatStyles', startDate: 'date' }
  const sortingComponents = ppvColumns
    ?.filter(({ sortable }) => sortable)
    .reduce(
      (acc, { value }) => ({
        ...acc,
        [value]: (
          <Popup
            trigger={
              <div className="icon icon-arrow" style={{ width: '1.2rem', height: '1.2rem', marginLeft: '5px' }} />
            }
            contentStyle={{ width: 'auto' }}
          >
            {(close) => (
              <Shared.SortingComponent
                close={close}
                column={value}
                availableSort={availableSort}
                availableFilters={availableFilters}
                keyMap={keyMap}
              />
            )}
          </Popup>
        ),
      }),
      {}
    )

  return (
    <div className="screen-activities-content" style={{ height: 'calc(100% - 9% - 1rem)' }}>
      {loading && !page ? (
        <Shared.LoaderInline />
      ) : (
        <Shared.Table
          fixedWidth
          columns={ppvColumns}
          data={docs}
          handlePagination={handlePagination}
          sortingComponent={sortingComponents}
          renderCell={(row, column) => renderCell.ppv(row, column, { navigate })}
          loader={loading}
        />
      )}
    </div>
  )
}
